<template>

  <div class="container pb-5 px-1 px-sm-3">
      <div v-if="loading" class="d-flex justify-content-center"><img src="../assets/images/loading.gif" alt="Φόρτωση" width="32"></div>
      <div v-else-if="error">{{ error }}</div>
      <div v-else>
        <div class="row no-gutters">
          <div class="col-12 px-0 px-sm-3">
            <div class="event-image-wrap">
              <img class="event-image" :src="event.event_img_url" alt="Event image">
            </div>
          </div>
          <div class="col-12 col-md-5 px-0 px-sm-3">
              <div class="event-info-wrap w-sm-100">
                  <p class="event-venue-title">
                    <img class="location-icon" src="../assets/images/location-icon.png">
                    {{ event.venue.title }}
                  </p>
                  <p class="event-title">{{ event.title }}</p>
                  <p class="event-date">
                     <img class="calendar-icon" src="../assets/images/calendar-icon.png">
                    {{ event.earliestDate === event.latestDate 
                    ? event.earliestDate 
                    : event.earliestDate + ' - ' + event.latestDate }}
                  </p>       
              </div>
          </div>
          <div class="col-12 col-md-7 pt-3 d-flex flex-column justify-content-end ">
            <div class="row">
                <div class="col-12 ticket-graphic-wrap">
                     <img class="ticket-graphic" src="../assets/images/tickets-icon.png">
                </div>
            </div>
            
            <div class="row ticket-navigation-wrap mt-3">
             <div class="col-4 page-nav-wrap">
                <nav class="page-nav" 
                    :class="{ active: activeTab === 'description' }" 
                    @click="scrollToSection('description')">
                  Περιγραφή
                </nav>
              </div>
              <div class="col-4 page-nav-wrap">
                <nav class="page-nav" 
                    :class="{ active: activeTab === 'zones' }" 
                    @click="scrollToSection('zones')">
                  Ζώνες Εισιτηρίων
                </nav>
              </div>
              <div class="col-4 page-nav-wrap">
                <nav class="page-nav" 
                    :class="{ active: activeTab === 'dates' }" 
                    @click="scrollToSection('dates')">
                  Ημερομηνίες
                </nav>
              </div>
            </div>
          </div>
          <div class="col-12 mt-5" ref="descriptionSection">
            <h3>Περιγραφή</h3>
          </div>

          <div class="col-12 col-md-8 mt-2">
            <p class="description">{{ event.description }}</p>
          </div>
                
          <div v-if="event.zones && event.zones.length" class="mt-2 col-8">
            <h3 class="col-12 mt-2" ref="zonesSection">Ζώνες Εισιτηρίων</h3>
            <ul class="list-unstyled mb-0">
              <li class="zone-title" v-for="(zone, index) in event.zones" :key="index">
                | {{ zone.title }} - Τιμή Εισιτηρίου {{ zone.price }} €
              </li>
              <!-- <div  class="mt-2" v-for="(zone, index) in event.zones" :key="'count-' + index">
                <p class="ticket-text">
                  Συνολικός αριθμός διαθέσιμων Εισιτηρίων στη 
                  <span class="ticket-text-bold">Ζώνη {{ zone.title }} : {{ zone.available_tickets }}</span>
                </p>
              </div>   -->
            </ul>
          </div>


        
          <div class="col-12 col-md-4">
              <div class="zone-image-wrap" v-if="event.zone_img_url">
                <img class="zone-image" :src="event.zone_img_url" alt="Zone image">
              </div>
          </div>

          <h3 class="col-12 mt-3" ref="datesSection">Ημερομηνίες</h3>
           <div class="desktop-table">
            <table class="table align-middle">
              <tbody>
                <tr v-for="(eventDate, index) in event.event_dates" :key="eventDate.id">
                  <td style="width: 8%;">
                    <span class="bold-text">{{ eventDate.formatted_date }}</span><br>
                    {{ eventDate.start_time }}
                  </td>
                  <td>
                    <span class="bold-text">{{ event.title }}</span><br>
                    {{ event.venue.title }}
                  </td>
                  <td>
                    <select v-model="selectedZones[index]" class="form-select" :disabled="!isBasicUser">
                      <option value="null">Ζώνη</option>
                      <option v-for="zone in event.zones" :key="zone.id" :value="zone.id">
                        {{ zone.title }} - {{ zone.price }} €
                      </option>
                    </select>
                  </td>
                  <td v-if="event.special_category_discounts && event.special_category_discounts.length">
                    <select v-model="selectedDiscounts[index]" class="form-select" :disabled="!isBasicUser">
                      <option value="null">Είδος Έκπτωσης</option>
                      <option v-for="discount in event.special_category_discounts" :key="discount.id" :value="discount.id">
                        {{ discount.title }} - {{ discount.discount }}%
                      </option>
                    </select>
                  </td>
                  <td class="text-center">
                    <img class="minus-icon" src="../assets/images/minus-icon.png" alt=""  @click="isBasicUser && decreaseTickets(index)">
                    <input class="ticket-number" type="number" v-model.number="ticketCounts[index]" min="0" :disabled="!isBasicUser">
                    <img class="plus-icon" src="../assets/images/plus-icon.png" alt=""  @click="isBasicUser && increaseTickets(index)">
                  </td>
                  <td class="text-center text-primary fw-bold fs-5">
                    {{ finalPrice(index).toFixed(2) }} €
                  </td>
                  <td>
                    <span
                      class="cart-img-wrap"
                      :class="{ 'disabled-icon': !isBasicUser }"
                      @click="isBasicUser && addToCart(index)"
                    >
                      Προσθήκη στο
                      <img class="cart-img" src="../assets/images/cart-icon-white.png">
                    </span>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

          <div class="mobile-cards mt-3">
            <div v-for="(eventDate, index) in event.event_dates" :key="eventDate.id" class="event-card">
              <div class="card-date-wrap">
                  Ημερομηνία {{ eventDate.formatted_date }} Ώρα: {{ eventDate.start_time }}
              </div>
              <div>
                <p class="event-title">{{ event.title }}</p>
                <p class="event-venue-title">{{ event.venue.title }}</p>
              </div>
              <div>
                <select v-model="selectedZones[index]" class="form-select" :disabled="!isBasicUser">
                  <option value="null">Ζώνη</option>
                  <option v-for="zone in event.zones" :key="zone.id" :value="zone.id">
                    {{ zone.title }} - {{ zone.price }} €
                  </option>
                </select>
              </div>
              <div  v-if="event.special_category_discounts && event.special_category_discounts.length">
                <select v-model="selectedDiscounts[index]" class="form-select" :disabled="!isBasicUser">
                  <option value="null">Είδος Έκπτωσης</option>
                  <option v-for="discount in event.special_category_discounts" :key="discount.id" :value="discount.id">
                    {{ discount.title }} - {{ discount.discount }}%
                  </option>
                </select>
              </div>
              <div class="row"> 
                <div class="col-6">
                  <button  @click="isBasicUser && decreaseTickets(index)">-</button>
                  <input type="number" v-model.number="ticketCounts[index]" min="0" :disabled="!isBasicUser">
                  <button @click="isBasicUser && increaseTickets(index)">+</button>
                </div>
                <div class="col-6 price">
                  {{ finalPrice(index).toFixed(2) }} €
                </div>
              </div>
             
              <div class="add-to-cart-wrap mt-2" :class="{ 'disabled-icon': !isBasicUser }"  @click="isBasicUser && addToCart(index)">
                <button class='add-to-cart' >Προσθήκη στο καλάθι</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject, computed} from 'vue';
import { useRoute } from 'vue-router';
import { fetchEvent } from '@/services/events';
import { createOrUpdateCartItem } from '@/services/cart';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';



const route = useRoute();
const event = ref(null);
const loading = ref(true);
const error = ref(null);
const selectedZones = ref([]);
const selectedDiscounts = ref([]);
const ticketCounts = ref([]);
const descriptionSection = ref(null);
const zonesSection = ref(null);
const datesSection = ref(null);
const activeTab = ref('description');
const toast = useToast();
const cartCount = inject('cartCount');
const store = useStore();


const isBasicUser = computed(() => store.getters.isBasicUser);


function increaseTickets(index) {
  ticketCounts.value[index] = (ticketCounts.value[index] || 0) + 1;
}

function decreaseTickets(index) {
  if ((ticketCounts.value[index] || 0) > 0) {
    ticketCounts.value[index]--;
  }
}

async function addToCart(index) {
  const eventDate = event.value.event_dates[index];
  const zoneId = selectedZones.value[index];
  const discountId = selectedDiscounts.value[index];
  const quantity = ticketCounts.value[index] || 0;

  const payload = {
    event_date_id: eventDate.id,
    zone_id: zoneId,
    discount_id: discountId || null,
    quantity: quantity
  };

  const result = await createOrUpdateCartItem(payload);

  if (!result.success) {
    if (result.errors) {
        const allErrors = Object.values(result.errors).flat().join('\n');
        toast(allErrors);
    } else {
      
      if (result.message?.includes('Unauthenticated')) {
        toast('Συνδεθείτε ή εγγραφείτε για να συνεχίσετε.');
      } else {
        toast(result.message);
      }
    }
  } else {
    cartCount.value += quantity;
    toast('Προστέθηκε στο καλάθι')
  }

}


/*function finalPrice(index) {
  const zoneId = selectedZones.value[index];
  const discountId = selectedDiscounts.value[index];
  const count = ticketCounts.value[index] || 0;

  if (!zoneId || count === 0) return 0;

  const zone = event.value.zones.find(z => z.id === zoneId);
  const discount = event.value.special_category_discounts.find(d => d.id === discountId);

  if (!zone) return 0;

  const priceBeforeDiscount = zone.price * count;

  if (discount) {
    return priceBeforeDiscount * (1 - discount.discount / 100);
  }

  return priceBeforeDiscount;
}*/

function finalPrice(index) {
  const zoneId = selectedZones.value[index];
  const discountId = selectedDiscounts.value[index];
  const count = ticketCounts.value[index] || 0;

  if (!zoneId || count === 0 || !event.value) return 0;

  const zone = event.value.zones?.find(z => z.id === zoneId);

  const discount = event.value.special_category_discounts?.find(
    d => d.id === discountId
  );

  if (!zone) return 0;

  const priceBeforeDiscount = zone.price * count;

  if (discount) {
    return priceBeforeDiscount * (1 - discount.discount / 100);
  }

  return priceBeforeDiscount;
}

const scrollToSection = (section) => {
  const sectionRef = { description: descriptionSection, zones: zonesSection, dates: datesSection }[section]
  if (!sectionRef?.value) return

  const offset = 150;
  window.scrollTo({ top: sectionRef.value.offsetTop - offset, behavior: 'smooth' })
  activeTab.value = section
}


onMounted(async () => {
  try {

    store.dispatch('fetchUserData');

    loading.value = true;
    error.value = null;
    const data = await fetchEvent(route.params.id);
    event.value = data.data;

    // const length = event.value.event_dates.length;
    const length = event.value?.event_dates?.length || 0;
    selectedZones.value = Array(length).fill(null);
    selectedDiscounts.value = Array(length).fill(null);
    ticketCounts.value = Array(length).fill(0);
  } catch (err) {
    error.value = 'Failed to load event';
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
  .event-image-wrap {
    width: 100%;
    height: 250px;
    background-color: #e5e5e5;
    overflow: hidden;
  }

  .event-image {
    height: 100%;
    object-fit: contain;
    object-position: center center;
    display: block;
    margin: 0 auto;
  }

  .event-info-wrap{
    background-color: #af0036;
    padding: 8px;
    display: inline-block;
  }

  .event-info-wrap p{
    margin-bottom: 0;
    color:#fff;
  }

  .event-title{
    font-size:22px;
    font-weight: 700;
  }

  .event-venue-title{
    font-weight: 100;
  }

  .ticket-navigation-wrap{
    text-align: right;
  }

  .ticket-graphic-wrap{
    text-align: right;
  }

  .ticket-graphic{
    width: 100px;
    position: relative;
    left:5px;
  }

  .zone-title{
    font-weight: 600;
    line-height: 2.5;
  }

  h3{
    font-weight: 800;
  }

  .ticket-text{
    font-weight: 100;
    line-height: 1;
  }

  .ticket-text-bold{
    font-weight: 600;
  }

  .plus-icon{
   cursor: pointer;
  }

  .minus-icon{
   cursor:pointer;
  }

  .ticket-number{
    position:relative;
    width: 30px;
    height: 30px;
    background:none;
    border:none;
    text-align: center;
    vertical-align: middle; 
    line-height: 30px; 
    padding: 0;
    box-sizing: border-box;
    font-size: 16px;
  }

  .ticket-number::-webkit-outer-spin-button,
  .ticket-number::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Remove spinner in Firefox */
  .ticket-number[type=number] {
    -moz-appearance: textfield;
  }

  .ticket-row p{
    margin-bottom:0;
  }

  .bold-text{
    font-weight: 600;
  }

  .cart-img-wrap{
    cursor:pointer;
    /* width:50px; */
    position:relative;
    background: var(--primary-color);
    border-radius: 10px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items:center;
    color: white;
    font-weight: 600;
    gap: 5px;
  }

  .cart-img-wrap:hover{
    background: #7f0228;
    transition: .5s
  }

  .cart-img{
    width: 24px;
  }

  .cart-img-wrap::after {
    content: '';
    position: absolute;
    bottom:10%;
    right: -10px;
    height: 80%;
    width: 4px;
    background-color: #4fd32f;
    border-radius: 5px;
  }

  .calendar-icon,
  .location-icon{
    width:16px;
    position:relative;
    top:-2px;
    margin-right: 8px;
  }

  .page-nav{
    display: inline-block;
    cursor: pointer;
    position: relative;
  }

  .page-nav.active::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -5px;
    height: 4px;
    width: 100%;
    background-color: #af0036;
    border-radius: 5px;
  }

  .container h3{
    font-weight: 500;
  }

  .plus-icon{
    width: 20px;
  }

  .table {
    table-layout: fixed;
    width: 100%;
  }

  .table td {
    overflow: hidden;     
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .desktop-table { 
    display: block; 
  }
  .mobile-cards { 
    display: none; 
  }

  .price{
    font-weight: 700;
    font-size: 16px;
    text-align: right;
  }

  .add-to-cart-wrap{
    text-align: right;
  }

  .add-to-cart{
    width: fit-content;
    font-size: 14px;
  }

  .description{
    font-size: 16px;
  }

  .zone-image{
    width: 100%;
  }

  .disabled-icon {
    opacity: 0.4;
    pointer-events: none;
  }

  .form-select {
    background-color: #fff;
  }

  @media (max-width: 1199px) {  
    .event-image-wrap {
      height: 150px;
    }

    .event-title{
      font-size: 18px;
    }
  }

  @media (max-width: 992px) {
    .event-image-wrap{
      height: 150px;
    }
  }

  @media (max-width: 768px) {
    .desktop-table { 
      display: none; 
    }

    .mobile-cards { 
      display: block; 
    }
    
    .event-card {
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 25px;
      background: #fff;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    }

    .event-card > div {
      margin-bottom: 8px;
    }

    .event-card input[type="number"] {
      width: 50px;
      text-align: center;
      border:1px solid lightgray;
      border-radius: 8px;
      font-size: 14px;
      margin: 0px 5px 0px 5px;
      height: 32px;
    }

    .event-card button {
      padding: 5px 10px;
      border: none;
      border-radius: 8px;
      background-color: #af0036;
      color: #fff;
      cursor: pointer;
      margin-left:1px;
      margin-right:1px;
    }

    .event-card button:hover {
      background-color: #af0036;
    }

    .event-card select.form-select {
      width: 100%;
      padding: 5px;
      border-radius: 5px;
      border: 0px solid #ccc;
    }

    .card-date-wrap{
      font-size: 13px;
      font-weight: 500;
    }
    
    .price{
      font-size: 16px;
    }

    .zone-title{
      font-size: 13px;
    }

  }

  @media (max-width: 576px) {
    .page-nav-wrap{
      text-align: center;
    }

    /* .page-nav{
      font-size: 13px;
    } */

    .event-venue-title{
      font-size:14px;
      margin-bottom: 0px;
    }

    .event-title{
      font-size: 16px;
      margin-bottom: 0;
    }

    .ticket-graphic{
      display: none;
    }

    .zone-image-wrap{
      text-align: center;
    }
    
   
  }



</style>